import { HttpClient } from 'api/http-client';
import { User, ProjectConversationId, ProjectId } from 'api/models';
import { ProjectConversation, ProjectConversationLastSeenInfo } from './types';

class ProjectConversationsHttpClient extends HttpClient {
  public async getProjectConversationsList([, projectID]: ProjectId): Promise<
    ProjectConversation[]
  > {
    return this.get<ProjectConversation[]>(
      `/projects/${projectID}/project-conversations`,
    );
  }

  public async createProjectConversation(
    [, projectID]: ProjectId,
    data: Partial<ProjectConversation>,
  ): Promise<ProjectConversation> {
    return this.post(`/projects/${projectID}/project-conversations`, data);
  }

  public async getProjectConversation(
    [, projectID]: ProjectId,
    [, conversationId]: ProjectConversationId,
  ): Promise<ProjectConversation> {
    return this.get(
      `/projects/${projectID}/project-conversations/${conversationId}`,
    );
  }

  public async updateProjectConversation(
    [, projectID]: ProjectId,
    [, conversationId]: ProjectConversationId,
    data: Partial<ProjectConversation>,
  ): Promise<ProjectConversation> {
    return this.put(
      `/projects/${projectID}/project-conversations/${conversationId}`,
      data,
    );
  }

  public async deleteProjectConversation(
    [, projectID]: ProjectId,
    [, conversationId]: ProjectConversationId,
  ): Promise<ProjectConversation> {
    return this.delete(
      `/projects/${projectID}/project-conversations/${conversationId}`,
    );
  }

  public async addMembersToConversation(
    [, projectID]: ProjectId,
    [, conversationId]: ProjectConversationId,
    data: Partial<ProjectConversation>,
  ): Promise<ProjectConversation> {
    return this.post(
      `/projects/${projectID}/project-conversations/${conversationId}/add-members`,
      data,
    );
  }

  public async removeMembersToConversation(
    [, projectID]: ProjectId,
    [, conversationId]: ProjectConversationId,
    data: Partial<User>[],
  ): Promise<ProjectConversation> {
    return this.post(
      `/projects/${projectID}/project-conversations/${conversationId}/remove-members`,
      data,
    );
  }

  public async updateMembersLastSeen(
    [, projectID]: ProjectId,
    [, conversationId]: ProjectConversationId,
    data: Partial<ProjectConversationLastSeenInfo>,
  ): Promise<ProjectConversation> {
    return this.post(
      `/projects/${projectID}/project-conversations/${conversationId}/members/lastSeen`,
      data,
    );
  }
}

export const ProjectConversationsAPI = new ProjectConversationsHttpClient();
